import {
  Card,
  Grid,
  Box,
  Typography,
  IconButton,
  Chip,
  useMediaQuery,
  useTheme,
  Avatar,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useNavigate } from 'react-router-dom';
import routes from '../../Utils/routes';
import { getJobsBookmark, postJobsBookmark } from '../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { text } from 'stream/consumers';
import getSymbolFromCurrency from 'currency-symbol-map';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function JobCards(props: any) {
  const {
    value,
    userData,
    carrierJobs,
  } = props;

  console.log(value, "skdnsli");

  const [bookmarksData, setBookmarksData] = useState<any[]>([]);
  const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`${routes.jobDetails}/${value?.Id}`, {
      state: { breadCrumbs: value?.Job_Title__c },
    });
  };

  const fetchBookmarks = async () => {
    try {
      const res = await getJobsBookmark(userData.applicantId);
      const saved = res.data.savedJobs || [];
      setBookmarksData(saved);
      const bookmarked = saved.some((job: any) => job?.Id === value?.Id);
      setIsBookmarked(bookmarked);
    } catch (err) {
      console.error(err);
    }
  };

  const handleBookmark = async () => {
    const payLoad = {
      contactId: userData.applicantId,
      jobId: value.Id,
      isBookmarked: !isBookmarked,
    };

    try {
      const res = await postJobsBookmark(payLoad, userData.applicantId);
      if (res?.success) {
        setIsBookmarked(!isBookmarked);
        enqueueSnackbar({
          message: 'Bookmark updated successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        fetchBookmarks(); // Sync bookmarks list again
      } else {
        enqueueSnackbar({
          message: 'Something went wrong',
          variant: 'error',
          autoHideDuration: 1000,
        });
      }
    } catch (err) {
      enqueueSnackbar({
        message: 'Something went wrong',
        variant: 'error',
        autoHideDuration: 1000,
      });
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBookmarks();
  }, []);

  const date = new Date(value?.CreatedDate);
  const formattedDate =
    date.getDate().toString().padStart(2, '0') +
    '/' +
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '/' +
    date.getFullYear();

  const workplaceType = value?.Work_Place_Type__c?.split(';');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile1 = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div>
      {!isMobile ? (
     <Card
  sx={{
    backgroundColor: "#F6F8FB",
    padding: { xs: "10px", sm: "14px", md: "16px", lg: "18px" },
    cursor: "pointer",
    borderRadius: "9px",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.06)",
    width: "100%",
    height: { xs: "auto", sm: "auto", md: "220px", lg: "220px" },
    "@media (min-width: 1280px) and (max-width: 1300px)": {
      height: "35vh",
    },
  }}
>
  <Grid container alignItems="center" spacing={1}>
    {/* LOGO */}
    <Grid item xs={3} sm={2} md={2}>
      <Box
        sx={{
          background: "#fff",
          borderRadius: "6px",
          padding: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: { xs: 40, sm: 44, md: 50 },
          width: { xs: 40, sm: 44, md: 50 },
        }}
      >
        <img
          src={value?.Organization__r?.Logo_File_URL__c}
          alt="logo"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </Box>
    </Grid>

    {/* TITLE + LOCATION */}
    <Grid item xs={7} sm={8} md={7.5} textAlign="start" onClick={handleClick} sx={{ cursor: "pointer", marginLeft: '10px' }}>
      <Typography
        fontWeight={500}
        fontSize={{ xs: "13.5px", sm: "15px", md: "16px", lg: "17px" }}
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value?.Job_Title__c}
      </Typography>
      <Typography
        fontWeight={400}
        fontSize={{ xs: "10px", sm: "11px", md: "12px" }}
        color="#666"
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value?.Organization__r?.Name} • {value?.Location__c}
      </Typography>
    </Grid>

    {/* BOOKMARK */}
    <Grid item xs={2} sm={2} md={2}>
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={handleBookmark} size="small">
          {isBookmarked ? (
            <BookmarkIcon sx={{ color: "#585A64", fontSize: { xs: 18, sm: 20 } }} />
          ) : (
            <BookmarkBorderIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />
          )}
        </IconButton>
      </Box>
    </Grid>
  </Grid>

  {/* TAGS */}
  <Box
    display="flex"
    flexWrap="wrap"
    alignItems="center"
    gap={1}
    mt={1.5}
    onClick={handleClick}
    sx={{ cursor: "pointer" }}
  >
    {workplaceType?.map((val: any, idx: any) => (
      <Chip
        key={idx}
        label={val}
        size="small"
        sx={{
          backgroundColor: "#DFE7F2",
          color: "black",
          fontWeight: 400,
          fontSize: { xs: "9px", sm: "10px" },
          ml: idx === 0 ? 0 : 1,
          height: { xs: 20, sm: 22 },
          borderRadius: "6px",
        }}
      />
    ))}

    <Typography
      ml="auto"
      mt={{ xs: 1, sm: 0 }}
      fontSize={{ xs: "9.5px", sm: "11px" }}
      color="#666"
      whiteSpace="nowrap"
    >
      {value?.Posted_Days_Ago || "2 weeks ago"}
    </Typography>
  </Box>

  {/* EXPERIENCE */}
  <Box display="flex" alignItems="center" mt={1.5} onClick={handleClick} sx={{ cursor: "pointer" }}>
    <WorkOutlineIcon sx={{ fontSize: { xs: 12, sm: 14 }, color: "#373A45" }} />
    <Typography
      fontWeight={400}
      fontSize={{ xs: "9.5px", sm: "11px" }}
      ml={0.5}
      color="#373A45"
    >
      Experience: {value?.Experience_Start_Level__c ?? "0"}-
      {value?.Experience_End_Level__c ?? "0"} years
    </Typography>
  </Box>

  {/* SALARY */}
  <Box display="flex" alignItems="center" mt={1.2} onClick={handleClick} sx={{ cursor: "pointer" }}>
    <Typography color="#373A45" fontSize={{ xs: 11, sm: 12 }}>
      {value?.Currency_Type__c
        ? getSymbolFromCurrency(value?.Currency_Type__c) || "₹"
        : "₹"}
    </Typography>
    <Typography
      color="#373A45"
      fontWeight={500}
      fontSize={{ xs: "10.5px", sm: "12px" }}
      ml={0.5}
    >
      {value?.Salary_Start_Range__c}-{value?.Salary_End_Range__c}
    </Typography>
  </Box>

  {/* FOOTER */}
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    mt={2}
    flexWrap="wrap"
    gap={1}
  >
    {carrierJobs === "PostedByMe" ? (
      <Chip
        label={value?.Approval_Status__c || "Pending Approval"}
        size="small"
        sx={{
          backgroundColor:
            value?.Approval_Status__c === "Approved"
              ? "green"
              : value?.Approval_Status__c === "Rejected"
              ? "red"
              : "#FEEBBE",
          color:
            value?.Approval_Status__c === "Approved" ||
            value?.Approval_Status__c === "Rejected"
              ? "white"
              : "black",
          fontSize: "11px",
        }}
      />
    ) : (
      <Box display="flex" alignItems="center" gap={0.5}>
        <Typography fontSize={{ xs: "9px", sm: "10px" }} color="#666">
          Posted By:
        </Typography>
        <Avatar
          sx={{ width: 22, height: 22 }}
          src={value?.Posted_By_Image || value?.Organization__r?.Logo_File_URL__c}
          alt="posted by"
        />
        <Typography
          fontWeight={500}
          fontSize={{ xs: "10px", sm: "12px" }}
          color="#1C1C1C"
        >
          {value?.Posted_By_Name || value?.Organization__r?.Name}
        </Typography>
      </Box>
    )}

<ArrowForwardIcon
  sx={{ fontSize: 18, cursor: 'pointer' }}
  onClick={handleClick}
/>
  </Box>
</Card>

      ) : (
        <Card
          sx={{
            backgroundColor: '#F6F8FB',
            padding: '10px',
            height: '230px',
            cursor: 'pointer',
            overflow: 'hidden',
            borderRadius: '9px',
            boxShadow: 'none',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box
                  sx={{
                    height: '30px',
                    width: '30px',
                    background: '#FFFFFF',
                    borderRadius: '6px',
                    padding: '4px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={value?.Organization__r?.Logo_File_URL__c}
                    height="20px"
                    width="20px"
                    alt=''
                  />
                </Box>
                <IconButton onClick={handleBookmark} size="small" sx={{ mt: 1 }}>
                  {isBookmarked ? (
                    <BookmarkIcon sx={{ color: '#585A64', fontSize: '18px' }} />
                  ) : (
                    <BookmarkBorderIcon sx={{ fontSize: '18px' }} />
                  )}
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: 'left' }}>
              <Box onClick={handleClick}>
                <Typography fontWeight={500} fontSize={'15px'}>
                  {value?.Job_Title__c}
                </Typography>
                <Typography fontWeight={400} fontSize={'11px'}>
                  {value?.Organization__r?.Name}
                </Typography>
                <Typography fontWeight={500} fontSize={'10px'} mt={2}>
                  Location: {value?.Location__c}
                </Typography>
                <Box display="flex" mt={0.5} fontSize={'8px'} alignItems="center">
                  PayRange:
                  <Typography fontSize={12}>
                    {getSymbolFromCurrency(value?.Currency_Type__c) || '₹'}
                  </Typography>
                  <Typography fontWeight={500} fontSize={'10.5px'} ml={0.5}>
                    {value?.Salary_Start_Range__c}-{value?.Salary_End_Range__c}
                  </Typography>
                </Box>
                <Box marginTop={"12px"} display={"flex"} gap={"4px"} alignItems={"center"}>
                  <Typography fontSize={"9px"} textAlign={"start"}>Posted By : </Typography>
                  <Typography fontWeight={500} fontSize={"9px"}>{value?.Organization__r?.Name}</Typography>

                  {/* <Avatar alt="Remy Sharp" sx={{ height: '22px', width: '22px' }} src={value?.Organization__r?.Logo_File_URL__c} /> */}

                </Box>
                <Box display="flex" flexWrap="wrap" mt={1}>
                  {workplaceType?.map((val: any, idx: any) => (
                    <Chip
                      key={idx}
                      label={val}
                      size="small"
                      sx={{
                        backgroundColor: '#DFE7F2',
                        color: '#295FAA',
                        fontWeight: 400,
                        fontSize: '9px',
                        ml: idx === 0 ? 0 : 1,
                        mt: 0.5,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>
      )}
    </div>
  );
}
